import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useHistory, useLocation } from 'react-router-dom'
import { MODALS } from '../../../../constants'
import { getModalLocation } from '../../../../lib/modal'
import AddVoucher from './add-voucher'
import RecurringVouchers from './recurring-voucher'
import { CardWrapper, CardContent } from '../../../shared/settings/card'
import styles from './index.css'

function Vouchers({
  recurringVouchers,
  renewalStatus,
  addVoucherVisible,
  message
}) {
  const [activePanel, setActivePanel] = useState(null)
  const history = useHistory()
  const location = useLocation()

  const handleIveGotAVoucher = () => {
    history.push(getModalLocation(location, MODALS.qsParams.addVoucher))
  }

  return (
    <CardWrapper>
      <CardContent className={styles.cardContent}>
        {addVoucherVisible ? (
          <AddVoucher handleIveGotAVoucher={handleIveGotAVoucher} />
        ) : (
          <p className={styles.information}>{message}</p>
        )}
        <RecurringVouchers
          recurringVouchers={recurringVouchers}
          renewalStatus={renewalStatus}
          activePanel={activePanel}
          setActivePanel={setActivePanel}
        />
      </CardContent>
    </CardWrapper>
  )
}

Vouchers.propTypes = {
  renewalStatus: PropTypes.string.isRequired,
  recurringVouchers: PropTypes.arrayOf(
    PropTypes.shape({
      orderDetails: PropTypes.shape({
        productName: PropTypes.string.isRequired,
        voucherCode: PropTypes.string,
        status: PropTypes.string.isRequired,
        promotion: PropTypes.shape({
          endDate: PropTypes.string.isRequired,
          id: PropTypes.string.isRequired,
          amount: PropTypes.string.isRequired,
          isExhausted: PropTypes.bool
        })
      }).isRequired
    })
  ).isRequired,
  addVoucherVisible: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired
}

export default Vouchers
